import ContentComponent from './Content/Content'
import WrapperComponent from './Wrapper/Wrapper'
import SideBarComponent from './Sidebar/Sidebar'

export const Content = ContentComponent
export const Wrapper = WrapperComponent
export const Sidebar = SideBarComponent;
